import * as S from './styled'

const Space = ({ children, left = true, right = true }) => (
    <S.Space left={left} right={right}>{children}</S.Space>
)

export default Space
